import React, { useState, Fragment } from 'react'
import listQuery from 'gql/query/listTags'
import { ReactComponent as Delete } from '../shared/icons/delete.svg'
import { createTag, updateTag, deleteTag } from './mutation'
import Button from 'components/Button'
import { Add } from 'media/icons'
import get from 'lodash/get'
import { useMutation, updateQuery, useQuery } from 'components/graphql'

import { StyledContainer, StyledModal, StyledField, StyledNewField, StyledButton } from './styled'
import { objectCheck } from 'sections/options/sections/GlobalCashRegisters/pages/DeviceUpdate/DeviceUpdate'

const TagEditor = ({ tagType, tagTitles, fieldsSelect, customActions }) => {
	const [showModal, setShowModal] = useState(false)
	let { data = null } = useQuery(listQuery, { variables: { type: tagType }, skip: !tagType })
	if(!objectCheck(data)) {
		data = fieldsSelect
	}
	const [updateTagMutation] = useMutation(updateTag)
	const [deleteTagMutation] = useMutation(deleteTag)
	const handleUpdate = (tag, e, actions) => {
		if(!actions) {
			updateTagMutation({
				variables: { id: tag.id, type: tagType, name: e.target.value }
			})
		} else {
			actions.handlerUpdate(tag, e.target.value.trim())
		}
	}
	const handleDelete = (tag, actions) => {
		if(!actions) {
			deleteTagMutation({
				variables: { id: tag.id, type: tagType },
				update: updateQuery({
					query: listQuery,
					variables: { type: tagType }
				}, (draft, { mutationResult, readQuery }) => {
					draft.listTags = readQuery.filter(({ id }) => id !== get(mutationResult, 'id'))
				}),
				optimisticResponse: {
					__typename: 'Mutation',
					cashAssist: {
						__typename: 'CA_Mutation',
						deleteTag: {
							__typename: 'Tag',
							type: tagType,
							...tag
						}
					}
				}
			})
		} else {
			actions.handlerDelete(tag)
		}
	}
	const getFields = (actions) => {
		let tagArr = data.listTags || data || []
		tagArr = tagArr.map((tag, i) => (
			<TagField
				action={actions}
				key={tag.id}
				updateFunc={(e) => handleUpdate(tag, e, actions)}
				deleteFunc={() => handleDelete(tag, actions)}
				tag={tag}
			/>
		))
		tagArr.unshift(<NewTagField key='new' tagType={tagType} tagTitles={tagTitles} customActions={customActions} />)
		return (
			<StyledContainer>
				{tagArr}
			</StyledContainer>
		)
	}

	return(
		<Fragment>
			<StyledButton onClick={() => setShowModal(true)}>...</StyledButton>
			{showModal &&
				<StyledModal label={tagTitles?.mainTitle || 'Gruppen bearbeiten' } unmount={() => setShowModal(false)}>
					<p>Gruppierung</p>
					{getFields(customActions)}
					<Button status='primary' text='ok' onClick={() => setShowModal(false)}/>
				</StyledModal>
			}
		</Fragment>
	)
}

const TagField = ({ tag, updateFunc, deleteFunc }) => {
	return(
		<StyledField>
			<input onBlur={updateFunc} defaultValue={tag.name || tag.value} type='text'/>
			<Delete onClick={deleteFunc}/>
		</StyledField>
	)
}

const NewTagField = ({ tagType, tagTitles, customActions }) => {
	const [newTagName, setNewtagName] = useState('')
	const [createTagMutation] = useMutation(createTag)

	const handleCreate = () => {
		if(newTagName) {
			createTagMutation({
				variables: { type: tagType, name: newTagName },
				update: updateQuery({
					query: listQuery,
					variables: { type: tagType }
				}, (draft, { mutationResult, readQuery }) => {
					draft.listTags = [...readQuery, mutationResult]
				}),
				optimisticResponse: {
					__typename: 'Mutation',
					cashAssist: {
						__typename: 'CA_Mutation',
						createTag: {
							__typename: 'Tag',
							id: '-1',
							uid: '-1',
							name: newTagName,
							type: tagType
						}
					}
				}
			})
		}
		setNewtagName('')
	}
	return (
		<StyledNewField>
			<input placeholder={tagTitles?.placeholder || 'Geben Sie den Gruppennamen ein'} value={newTagName} onChange={e => setNewtagName(e.target.value)} type='text'/>
			<Add onClick={() => !customActions ? handleCreate() : customActions.handlerCreate({ setValue: setNewtagName, value: newTagName.trim() })} />
		</StyledNewField>
	)
}

export default TagEditor
